"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M10.11 3.519c.616-1.802 3.164-1.802 3.78 0a2 2 0 0 0 2.77 1.147c1.71-.838 3.512.964 2.674 2.674a2 2 0 0 0 1.148 2.77c1.8.616 1.8 3.164 0 3.78a2 2 0 0 0-1.148 2.77c.838 1.71-.964 3.511-2.674 2.674a2 2 0 0 0-2.77 1.147c-.616 1.802-3.164 1.802-3.78 0a2 2 0 0 0-2.77-1.147c-1.71.837-3.511-.964-2.674-2.674a2 2 0 0 0-1.147-2.77c-1.802-.616-1.802-3.164 0-3.78a2 2 0 0 0 1.147-2.77c-.837-1.71.964-3.512 2.674-2.674a2 2 0 0 0 2.77-1.147M6.9 5.563c-.854-.418-1.754.481-1.336 1.336a3 3 0 0 1-1.721 4.155c-.9.309-.9 1.581 0 1.89a3 3 0 0 1 1.72 4.155c-.417.854.483 1.754 1.337 1.336a3 3 0 0 1 4.155 1.721c.309.9 1.581.9 1.89 0a3 3 0 0 1 4.155-1.72c.855.417 1.754-.483 1.336-1.337a3 3 0 0 1 1.721-4.155c.9-.309.9-1.581 0-1.89a3 3 0 0 1-1.72-4.155c.417-.855-.482-1.754-1.337-1.336a3 3 0 0 1-4.155-1.721c-.309-.9-1.581-.9-1.89 0A3 3 0 0 1 6.9 5.563"
        })
    ]
}), 'Settings'); //# sourceMappingURL=index.js.map
